<template>
  <div class="sm:px-6 lg:px-8">
    <div class="h-full bg-white shadow-2xl">
      <user-table></user-table>
    </div>
  </div>
</template>

<script>
import UserTable from '@/components/UserTable'

export default {
  components: { UserTable },
}
</script>
